import { Navigate, Outlet, useLocation } from 'react-router';
import { useCurrentUser } from '@/hooks/use-current-user';
import { PageLoader } from './page-loader';

/**
 * /account is the trustee's personal page — on a mandate it redirects to the
 * company page. Search and hash are preserved so the fiduciaire-checkout
 * round trip still reports its result after the webhook switches the active
 * company to the freshly created mandate.
 */
export function OwnCompanyGate() {
  const { isLoading, isMandateSelected } = useCurrentUser();
  const location = useLocation();
  if (isLoading) return <PageLoader />;
  if (isMandateSelected) {
    return (
      <Navigate
        to={{
          pathname: '/company',
          search: location.search,
          hash: location.hash,
        }}
        replace
      />
    );
  }
  return <Outlet />;
}
